import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=4be04b88&scoped=true"
import script from "./BalanceDetail.vue?vue&type=script&lang=js"
export * from "./BalanceDetail.vue?vue&type=script&lang=js"
import style0 from "./BalanceDetail.vue?vue&type=style&index=0&id=4be04b88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be04b88",
  null
  
)

export default component.exports